import type { ArenaBounds, Player, Point } from "./models";

export const clampPoint = (point: Point, bounds: ArenaBounds): Point => ({
  x: Math.max(bounds.left, Math.min(bounds.right, point.x)),
  y: Math.max(bounds.top, Math.min(bounds.bottom, point.y)),
});

export class MovementSystem {
  move(player: Player, direction: Point, deltaSeconds: number, bounds: ArenaBounds): void {
    const magnitude = Math.hypot(direction.x, direction.y);
    if (magnitude === 0) return;

    const distance = player.speed * deltaSeconds;
    const next = clampPoint({
      x: player.position.x + (direction.x / magnitude) * distance,
      y: player.position.y + (direction.y / magnitude) * distance,
    }, bounds);

    player.position.x = next.x;
    player.position.y = next.y;
  }

  place(player: Player, position: Point, bounds: ArenaBounds): void {
    const next = clampPoint(position, bounds);
    player.position.x = next.x;
    player.position.y = next.y;
  }
}
